import { render, staticRenderFns } from "./PaymentArticlesUpdateComponent.vue?vue&type=template&id=37f5607b&scoped=true"
import script from "./PaymentArticlesUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./PaymentArticlesUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5607b",
  null
  
)

export default component.exports